import React from 'react'
import PropTypes from 'prop-types';
import application_contants from '../../contants/application_contants';

export default function FinalEvent({ section_id, currentIndex = 1 }) {

  return (
    <section id={section_id} className="finalevent-section">
      <div className="timeline-header">
        {/* <p className="timeline-subtitle title-navy-blue">The Path</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Final Event </h2>
      </div>


      {/* Adding timeline image from canva respin.syspin.web account */}
      <div >
        <h2 className="h3-medium section-title title-navy-blue pb-2 about-readmore-title">Join us for the Final Event</h2>
        <img src={application_contants.final_event } alt="Final Event Illustration" />
      </div>
      <br></br>

      <div className="event-timeline">
        <h2 className="h3-medium section-title title-navy-blue pb-2 about-readmore-title">Program schedule</h2>
        <table className="event-schedule-table">
          <thead className="event-schedule-thead">
          <tr className="event-schedule-header-row">
            <th className="event-schedule-th event-schedule-th-time">Timings</th>
            <th className="event-schedule-th event-schedule-th-event">Events</th>
          </tr>
          </thead>
          <tbody className="event-schedule-tbody">
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>09:00 - 10:30</td>
            <td className='event-schedule-td event-schedule-event'>Registrations, Team API finalization and handover</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>10:30 - 11:30</td>
            <td className='event-schedule-td event-schedule-event'>Introductory talks and seminars</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>11:30 - 12:00</td>
            <td className='event-schedule-td event-schedule-event'>Tea / Coffee Break</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>12:00 - 12:30</td>
            <td className='event-schedule-td event-schedule-event'>Poster Session (Finalists / Teams)</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>13:00 - 14:00</td>
            <td className='event-schedule-td event-schedule-event'>Networking Lunch</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>14:00 - 15:00</td>
            <td className='event-schedule-td event-schedule-event'>Presentation by Teams (10+5min for each team)</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>15:00 - 15:30</td>
            <td className='event-schedule-td event-schedule-event'>Jury visiting the eval team and audio sample</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>15:30 - 16:00</td>
            <td className='event-schedule-td event-schedule-event'>High Tea</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>16:00 - 16:30</td>
            <td className='event-schedule-td event-schedule-event'>Seminars</td>
          </tr>
          <tr className='event-schedule-row'>
            <td className='event-schedule-td event-schedule-time'>16:30 - 17:00</td>
            <td className='event-schedule-td event-schedule-event'>Results Announcements</td>
          </tr>

          </tbody>
        </table>
      </div>
        <br></br>   
    <div className="event-timeline">
        <h2 className="h3-medium section-title title-navy-blue pb-2 about-readmore-title">Speakers</h2>
        <div className="speakers-grid-container">
            {/* Speaker 1: Philipp Olbrich */}
            <div className="speaker-card">
                <a href='https://www.linkedin.com/in/philipp-olbrich-505a71108/' rel="noreferrer" target="_blank" className="speaker-image-link">
                    <img src={application_contants.philiph} alt="Philipp Olbrich" className="speaker-profile-img" />
                </a>
                <div className="speaker-name-wrapper">
                    <a href='https://www.linkedin.com/in/philipp-olbrich-505a71108/' rel="noreferrer" target="_blank" className="speaker-name-link title-black">
                        <h6 className="p-large jostBold font-size-20px">
                            Philipp Olbrich
                        </h6>
                        <p className="p-small jostBold mb-5 font-size-20px">
                            GIZ
                        </p>
                    </a>
                </div>
            </div>

            {/* Speaker 2: Amitabh Nag */}
            <div className="speaker-card">
                <a href='https://www.linkedin.com/in/amitabh-nag-56039b5/' rel="noreferrer" target="_blank" className="speaker-image-link">
                    <img src={application_contants.amithab_nag} alt="Amitabh Nag" className="speaker-profile-img" />
                </a>
                <div className="speaker-name-wrapper">
                    <a href='https://www.linkedin.com/in/amitabh-nag-56039b5/' rel="noreferrer" target="_blank" className="speaker-name-link title-black">
                        <h6 className="p-large jostBold font-size-20px">
                            Amitabh Nag
                        </h6>
                        <p className="p-small jostBold mb-5 font-size-20px">
                            BHASHINI
                        </p>
                    </a>
                </div>
            </div>

            {/* Speaker 3: Kruti Dalal */}
            <div className="speaker-card">
                <a href='https://www.linkedin.com/in/kruti-dalal/' rel="noreferrer" target="_blank" className="speaker-image-link">
                    <img src={application_contants.kruthi_dalal} alt="Kruti Dalal" className="speaker-profile-img" />
                </a>
                <div className="speaker-name-wrapper">
                    <a href='https://www.linkedin.com/in/kruti-dalal/' rel="noreferrer" target="_blank" className="speaker-name-link title-black">
                        <h6 className="p-large jostBold font-size-20px">
                            Kruti Dalal
                        </h6>
                        <p className="p-small jostBold mb-5 font-size-20px">
                            ARMMAN 
                        </p>
                    </a>
                </div>
            </div>

            {/* Speaker 4: Raghu Dharmaraju */}
            <div className="speaker-card">
                <a href='https://www.cgi.com/india/en/experts/raghu-dharmaraju' rel="noreferrer" target="_blank" className="speaker-image-link">
                    <img src={application_contants.raghu_d} alt="Raghu D" className="speaker-profile-img" />
                </a>
                <div className="speaker-name-wrapper">
                    <a href='https://www.cgi.com/india/en/experts/raghu-dharmaraju' rel="noreferrer" target="_blank" className="speaker-name-link title-black">
                        <h6 className="p-large jostBold font-size-20px">
                            Raghu Dharmaraju
                        </h6>
                        <p className="p-small jostBold mb-5 font-size-20px">
                            CEO, ARTPARK at IISc Bangalore
                        </p>
                    </a>
                </div>
            </div>

            {/* Speaker 5: Bharadwaj Amrutur */}
            <div className="speaker-card">
                <a href='https://eecs.iisc.ac.in/people/bharadwaj-amrutur/' rel="noreferrer" target="_blank" className="speaker-image-link">
                    <img src={application_contants.bharadwaj_a} alt="Bharadwaj A" className="speaker-profile-img" />
                </a>
                <div className="speaker-name-wrapper">
                    <a href='https://eecs.iisc.ac.in/people/bharadwaj-amrutur/' rel="noreferrer" target="_blank" className="speaker-name-link title-black">
                        <h6 className="p-large jostBold font-size-20px">
                            Bharadwaj Amrutur
                        </h6>
                        <p className="p-small jostBold mb-5 font-size-20px">
                            Division of Electrical, Electronics, and Computer Sciences, IISc Bangalore
                        </p>
                    </a>
                </div>
            </div>

            {/* Speaker 6: Deekshitha G */}
            <div className="speaker-card">
                <a href='https://www.linkedin.com/in/deekshu50/' rel="noreferrer" target="_blank" className="speaker-image-link">
                    <img src={application_contants.deekshitha} alt="Deekshitha G" className="speaker-profile-img" />
                </a>
                <div className="speaker-name-wrapper">
                    <a href='https://www.linkedin.com/in/deekshu50/' rel="noreferrer" target="_blank" className="speaker-name-link title-black">
                        <h6 className="p-large jostBold font-size-20px">
                            Deekshitha G
                        </h6>
                        <p className="p-small jostBold mb-5 font-size-20px">
                            SPIRE Lab, IISc Bangalore
                        </p>
                    </a>
                </div>
            </div>

            {/* Speaker 7: Jesuraj Bandekar */}
            <div className="speaker-card">
                <a href='https://www.linkedin.com/in/jesurajbandekar/' rel="noreferrer" target="_blank" className="speaker-image-link">
                    <img src={application_contants.jesuraj} alt="Jesuraj Bandekar" className="speaker-profile-img" />
                </a>
                <div className="speaker-name-wrapper">
                    <a href='https://www.linkedin.com/in/jesurajbandekar/' rel="noreferrer" target="_blank" className="speaker-name-link title-black">
                        <h6 className="p-large jostBold font-size-20px">
                            Jesuraj Bandekar
                        </h6>
                        <p className="p-small jostBold mb-5 font-size-20px">
                            SPIRE Lab, IISc Bangalore
                        </p>
                    </a>
                </div>
            </div>

            {/* Speaker 8: Pranav D Bhatt */}
            <div className="speaker-card">
                <a href='https://www.linkedin.com/in/pranav-d-bhat-1864521b4/' rel="noreferrer" target="_blank" className="speaker-image-link">
                    <img src={application_contants.pranav} alt="Pranav D Bhatt" className="speaker-profile-img" />
                </a>
                <div className="speaker-name-wrapper">
                    <a href='https://www.linkedin.com/in/pranav-d-bhat-1864521b4/' rel="noreferrer" target="_blank" className="speaker-name-link title-black">
                        <h6 className="p-large jostBold font-size-20px">
                            Pranav D Bhatt
                        </h6>
                        <p className="p-small jostBold mb-5 font-size-20px">
                            ARTPARK, IISc Bangalore
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </div>

    </section>
  )
}

FinalEvent.propTypes = {
  section_id:   PropTypes.string.isRequired,
  currentIndex: PropTypes.number  // zero-based index of last completed event
}
FinalEvent.defaultProps = {
  currentIndex: 1  // by default, second event is “active”
}
